import { effects as campaignsEffects } from './campaignsCreation';
import { effects as campaignsListsEffects } from './campaignsLists';
import { effects as campaignsEditEffects } from './campaignsEdit';
import { effects as campaignsDetailsEffects } from './campaignsDetails';
import { effects as discountsListsEffects } from './discountsLists';
import { effects as discountsEditEffects } from './discountsEdit';

const effects = {
    ...campaignsEffects,
    ...campaignsListsEffects,
    ...campaignsEditEffects,
    ...campaignsDetailsEffects,
    ...discountsListsEffects,
    ...discountsEditEffects,
};

export default effects;
